// extracted by mini-css-extract-plugin
export default {"root":"ZpyG8ae3"};